import React from "react";
import { ServicesProvider } from "./context/services-context";
import { ServicesPage } from "./services.page";

export function ServicesFactory() {

    return (
        <ServicesProvider>
            <ServicesPage></ServicesPage>
        </ServicesProvider>
    );
}